import { classNames } from "../../helpers";
import ChangeLangButton from "../language/ChangeLangButton";

type ContainerSmProps = {
  children?: React.ReactNode;
  className?: String;
};

export default function ContainerSm({ children, className }: ContainerSmProps) {
  return (
    <div className="min-h-screen flex flex-col justify-between py-12  px-8 sm:px-6 lg:px-8">
      <div
        className={classNames("sm:mx-auto max-w-[576px] sm:w-auto", className)}
      >
        {children}
      </div>
      <ChangeLangButton />
    </div>
  );
}
